<template>
  <div>
    <div v-if="isTax" class="row__dropdown" ref="dropdown">
      <div class="row__dropdown-item row__dropdown-item--delete icon__taxes" @click="onTaxes()" ref="dropdownTaxes">
        Taxes
      </div>
    </div>
    <div v-else class="row__dropdown" ref="dropdown">
      <div v-if="can('customer_edit')" class="row__dropdown-item row__dropdown-item--edit icon__edit" @click="onEdit()" ref="dropdownEdit">
        {{ $t(`buttons.${"editBtn"}`) }}
      </div>
      <div v-if="can('customer_separate')"
        class="row__dropdown-item row__dropdown-item--separate icon__separate" @click="onSeparate()"
        ref="dropdownSeparate">
        {{ $t(`buttons.${"separateBtn"}`) }}
      </div>
      <div v-if="can('customer_delete')" class="row__dropdown-item row__dropdown-item--delete icon__delete" @click="onDelete()" ref="dropdownDelete">
        {{ $t(`buttons.${"deleteBtn"}`) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

defineOptions({
  name: "MembersActionDropdown"
});

// Explicit component communication rules
const props = defineProps({
  onEdit: {
    required: false,
    type: Function,
  },
  onDelete: {
    required: false,
    type: Function,
  },
  onSeparate: {
    required: false,
    type: Function,
  },
  isTax: {
    required: true,
    type: Boolean,
  },
  onTaxes: {
    required: false,
    type: Function,
  },
  teamId: {
    required: false,
    type: [Number, String],
    default: null,
  },
});

const store = useStore();
const can = (ability) => {
  if (store.getters.isSuperAdmin) return true;
  return store.getters.hasTeamPermission(ability, props.teamId);
};

const emit = defineEmits(["toggleDropdown"]);

// Component Template Template DOM Refs
const dropdown = ref(null);
const dropdownEdit = ref(null);
const dropdownDelete = ref(null);
const dropdownSeparate = ref(null);

// Event boundary tracking method
const checkIfClickedInside = (event) => {
  const { target } = event;

  if (
    target === dropdown.value?.parentElement ||
    target === dropdownEdit.value ||
    target === dropdownDelete.value ||
    target === dropdownSeparate.value
  ) {
    emit("toggleDropdown", true);
  } else {
    emit("toggleDropdown", false);
  }
};

// Component Lifecycle Hooks
onMounted(() => {
  document.addEventListener("click", checkIfClickedInside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", checkIfClickedInside);
});
</script>

<style>
.table .row__dropdown-item--separate {
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
}

.icon__separate {
  background: url("~@/assets/icons/default/separate_icon.svg") no-repeat center;

}
</style>
